/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import qs from 'query-string'
import { useLocation, useHistory } from 'react-router-dom'

const useFilter = ({ initialFilter = {}, blacklist = [] } = {}) => {
  const location = useLocation()
  const history = useHistory()
  const search = qs.parse(location.search)

  const [filters, setFilters] = useState(
    Object.fromEntries(
      Object.entries({ ...initialFilter, ...search }).filter(
        ([key]) => !blacklist.includes(key),
      ),
    ),
  )

  const [drawerOpen, setIsDrawerOpen] = useState(false)
  const [alreadyOpen, setAlreadyOpen] = useState(false)

  const setDrawerOpen = (open) => {
    if (!alreadyOpen && !open) {
      setAlreadyOpen(true)
    }
    setIsDrawerOpen(open)
  }

  useEffect(() => {
    const updatedFilters = Object.keys(filters)
      .filter((key) => !!filters[key])
      .reduce((obj, key) => ((obj[key] = filters[key]), obj), {})

    history.replace(location.pathname + '?' + qs.stringify(updatedFilters))
  }, [filters])
  return { filters, setFilters, drawerOpen, setDrawerOpen, alreadyOpen }
}

export default useFilter
